var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseMobileModalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4193 13.5781C15.8411 14.0469 15.8411 14.75 15.4193 15.1719C14.9505 15.6406 14.2474 15.6406 13.8255 15.1719L8.29426 9.59375L2.71614 15.1719C2.24739 15.6406 1.54426 15.6406 1.12239 15.1719C0.653639 14.75 0.653639 14.0469 1.12239 13.5781L6.70051 8L1.12239 2.42188C0.653639 1.95312 0.653639 1.25 1.12239 0.828125C1.54426 0.359375 2.24739 0.359375 2.66926 0.828125L8.29426 6.45312L13.8724 0.875C14.2943 0.40625 14.9974 0.40625 15.4193 0.875C15.888 1.29688 15.888 2 15.4193 2.46875L9.84114 8L15.4193 13.5781Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseMobileModalIcon);
export default __webpack_public_path__ + "static/media/closeMobileModalIcon.ad9d5f63152fe1597f2a9e81cc8fd139.svg";
export { ForwardRef as ReactComponent };